import React from 'react';
import { portfolioData } from '../mock';
import { useReveal } from '../hooks/useReveal';

const ExperienceCard = ({ item, index }) => {
  const [ref, visible] = useReveal();
  return (
    <div
      ref={ref}
      data-testid={`experience-${index}`}
      className={`reveal ${visible ? 'is-visible' : ''} grid md:grid-cols-12 gap-6 md:gap-10 py-12 border-t border-[hsl(var(--rule))] first:border-t-0`}
      style={{ transitionDelay: `${index * 60}ms` }}
    >
      <div className="md:col-span-3 mono text-xs text-[hsl(var(--foreground-faint))] md:pt-2">
        {item.duration}
      </div>
      <div className="md:col-span-9 space-y-5">
        <div>
          <h3 className="display text-2xl sm:text-3xl leading-tight">
            {item.position}
          </h3>
          <p className="mono text-sm text-[hsl(var(--accent))] mt-1">
            @ {item.company}
          </p>
        </div>
        <p className="text-lg text-[hsl(var(--foreground-muted))] leading-relaxed max-w-3xl">
          {item.summary}
        </p>
        <ul className="space-y-3 max-w-3xl">
          {item.points.map((p, i) => (
            <li key={i} className="flex gap-3 text-[hsl(var(--foreground))] leading-relaxed">
              <span className="mono text-[hsl(var(--accent))] mt-1 flex-shrink-0">{String(i + 1).padStart(2, '0')}.</span>
              <span>{p}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const Experience = () => {
  const [headRef, headVisible] = useReveal();

  return (
    <section
      id="experience"
      data-testid="experience-section"
      className="py-28 sm:py-36 px-5 sm:px-8 lg:px-12 border-t border-[hsl(var(--rule))] bg-[hsl(var(--surface))]"
    >
      <div className="max-w-6xl mx-auto">
        <div
          ref={headRef}
          className={`reveal ${headVisible ? 'is-visible' : ''} grid lg:grid-cols-12 gap-8 lg:gap-16 mb-12`}
        >
          <div className="lg:col-span-4">
            <div className="section-label mb-6">
              <span>02 / experience</span>
            </div>
            <h2 className="display text-4xl sm:text-5xl leading-tight">
              Where I've
              <br />
              shipped things.
            </h2>
          </div>
          <div className="lg:col-span-8 lg:pt-3">
            <p className="text-xl text-[hsl(var(--foreground-muted))] leading-relaxed max-w-2xl">
              Moving between product teams and research groups — building backend services, event-driven cloud systems, and AI pipelines. Some weeks it's a stubborn pipeline bug, some weeks a new Bedrock workflow. Most weeks, both.
            </p>
          </div>
        </div>

        <div>
          {portfolioData.experience.map((exp, i) => (
            <ExperienceCard key={exp.id} item={exp} index={i} />
          ))}
        </div>

        {/* small numerical strip */}
        <div className="mt-16 pt-10 border-t border-[hsl(var(--rule))] grid grid-cols-2 md:grid-cols-4 gap-8">
          {[
            { num: '4', label: 'engineering roles' },
            { num: '3+', label: 'years building backend & AI systems' },
            { num: 'AWS', label: 'event-driven workflows' },
            { num: '2', label: 'peer-reviewed papers' },
          ].map((s, i) => (
            <div key={i} data-testid={`stat-${i}`}>
              <div className="display text-4xl sm:text-5xl text-[hsl(var(--accent))] mb-2">{s.num}</div>
              <div className="mono text-[0.72rem] text-[hsl(var(--foreground-faint))] uppercase tracking-wider">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
